import { httpGet } from "../Web";
import { ApiResponse } from "./ApiResponse";
import { TestCase } from "./TestCase";

export interface Interface {
    name: string,
    shortName: string,
    status: number,
    guid: string,
    id: number
};

export enum InterfaceStatus {
    Draft = 0, Released = 1, Disabled = 2
}

export const InterfaceStatusStrings = ["Draft", "Released", "Disabled"];
export const InterfacePropFieldTypeStrings = ["TextBox", "MultiLineBox", "CheckBox", "OptionList", "Table"];

export enum FieldType {
    TextBox = 0,
    MultiLineBox = 1,
    CheckBox = 2,
    OptionList = 3,
    Table = 4
};

export interface InterfaceProperty {
    id: number,
    interfaceId: number,
    group: string,
    name: string,
    fieldType: FieldType,
    fieldSchema: string
};

export interface IfacePropertySchema {
    maxRows: number,
    minRows: number,
    isRequired?: boolean,
    columns: string[]
};

export const enumerateInterfaces = (abortController: AbortController): Promise<ApiResponse<Interface[]>> =>
    httpGet('/api/interface', abortController);

export const getInterfaceTestcases = (id: number, abortController: AbortController): Promise<ApiResponse<TestCase[]>> =>
    httpGet(`/api/interface/testcase/${id}`, abortController);

export const getInterfaceProperties = (id: number, abortController: AbortController): Promise<ApiResponse<InterfaceProperty[]>> =>
    httpGet(`/api/interface/property/${id}`, abortController);

export const getInterfacePropertySingle = (id: number, abortController: AbortController): Promise<ApiResponse<InterfaceProperty>> =>
    httpGet(`/api/interface/propertysingle/${id}`, abortController);
